/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menufullremoved2Inputs */

const en_menufullremoved2 = /** @type {(inputs: Menufullremoved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu removed`)
};

const de_menufullremoved2 = /** @type {(inputs: Menufullremoved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speisekarte entfernt`)
};

/**
* | output |
* | --- |
* | "Menu removed" |
*
* @param {Menufullremoved2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menufullremoved2 = /** @type {((inputs?: Menufullremoved2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menufullremoved2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menufullremoved2(inputs)
	return de_menufullremoved2(inputs)
});
export { menufullremoved2 as "menuFullRemoved" }